import api from './api';

const BASE_URL = '/cycle-codes';

class CycleCodeService {
  constructor() {
    this.httpClient = api;
  }

  async currentCycleById(idCycle) {
    try {
      const currentCycle = await (await this.httpClient.get(`${BASE_URL}/${idCycle}`)).data;
      return currentCycle;
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }

  async getFirstCycleCode() {
    try {
      const response = await (await api.get(`${BASE_URL}`)).data;
      return response[response.length - 1];
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }

  async getCycles() {
    try {
      const cycles = (await this.httpClient.get(BASE_URL)).data;
      return cycles;
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }
}

export default new CycleCodeService();
